module.exports = __webpack_public_path__ + "static/media/2A9JHW6.crop.cc27ac08.jpg";